import { PAYMENT_STATUS, PAYMENT_STATUS_LABELS } from "../utils/enums";
import SortDropdown from "./SortDropdown";

const ORDER = [
  PAYMENT_STATUS.ALL,
  PAYMENT_STATUS.JOINED,
  PAYMENT_STATUS.PAID,
  PAYMENT_STATUS.PAYMENT_REVIEW_FLAGGED,
  PAYMENT_STATUS.TRACKED,
  PAYMENT_STATUS.DELIVERED,
  PAYMENT_STATUS.COMPLAINED,
  PAYMENT_STATUS.COMPLAINT_PERIOD_ENDED,
  PAYMENT_STATUS.CLAIMED,
  PAYMENT_STATUS.FUNDS_RELEASED,
  PAYMENT_STATUS.CANCELLED,
  PAYMENT_STATUS.FUNDS_REFUNDED,
  PAYMENT_STATUS.PAYMENT_FAILED,
];

// Terminal-failure states are only surfaced to the buyer (a cancelled/failed
// attempt they made). Sellers never see them — the API also enforces this, so
// hiding the options just keeps the filter honest.
const FAILED = [
  PAYMENT_STATUS.CANCELLED,
  PAYMENT_STATUS.FUNDS_REFUNDED,
  PAYMENT_STATUS.PAYMENT_FAILED,
];

const PaymentStatusDropdown = ({ value, onChange, includeFailed = true }: any) => {
  const order = includeFailed ? ORDER : ORDER.filter((v) => !FAILED.includes(v));
  const options = order.map((v) => ({ value: v, label: PAYMENT_STATUS_LABELS[v] }));
  return (
    <SortDropdown
      label="Status"
      icon="bi-funnel"
      options={options}
      value={value || PAYMENT_STATUS.ALL}
      onChange={onChange}
    />
  );
};

export default PaymentStatusDropdown;
